import defaultConfig from './timing.json';

export const LANES = Object.fromEntries(
  defaultConfig.lanes.map(l => [l.id, l])
);

export const DEFAULT_LANE = defaultConfig.lanes[0].id;

export const LOOPS = defaultConfig.loops;

export const FINISH_LOOP = defaultConfig.finishLoop;

const BUITENBAAN_TOTAL = defaultConfig.lanes.find(l => l.id === 'buitenbaan')?.distance ?? 412.4532;

// Default lane lengths sourced from timing.json — the single source of truth
// for the hard-coded lane lengths that were scattered across
// LiveView (TRACK_LEN), TrackSVG (BUITENBAAN_TOTAL) and SeasonView (BAAN_M).
export const DEFAULT_BUITENBAAN_M = BUITENBAAN_TOTAL;
export const DEFAULT_BINNENBAAN_M =
  defaultConfig.lanes.find(l => l.id === 'binnenbaan')?.distance ?? 387.3205;

function isCurveSection(fromLoop, toLoop) {
  return !!(fromLoop.curve && toLoop.curve);
}

function buildStraightTotal(loops, buiten) {
  return loops.reduce((sum, loop, i) => {
    const next = loops[(i + 1) % loops.length];
    if (isCurveSection(loop, next)) return sum;
    const rawDist = i < loops.length - 1
      ? next.cumDist - loop.cumDist
      : buiten - loop.cumDist;
    return sum + rawDist;
  }, 0);
}

export function getCurveScale(lane = DEFAULT_LANE, cfg = defaultConfig) {
  const loops  = cfg.loops ?? LOOPS;
  const buiten = cfg.lanes?.find(l => l.id === 'buitenbaan')?.distance ?? BUITENBAAN_TOTAL;
  const laneTotal = cfg.lanes?.find(l => l.id === lane)?.distance
    ?? LANES[lane]?.distance ?? buiten;
  const straight   = buildStraightTotal(loops, buiten);
  const curveBuiten = buiten - straight;
  if (curveBuiten === 0) return 1;
  return (laneTotal - straight) / curveBuiten;
}

export function getSectionDistances(lane = DEFAULT_LANE, cfg = defaultConfig) {
  const loops  = cfg.loops ?? LOOPS;
  const buiten = cfg.lanes?.find(l => l.id === 'buitenbaan')?.distance ?? BUITENBAAN_TOTAL;
  const curveScale = getCurveScale(lane, cfg);
  return loops.map((loop, i) => {
    const next    = loops[(i + 1) % loops.length];
    const rawDist = i < loops.length - 1
      ? next.cumDist - loop.cumDist
      : buiten - loop.cumDist;
    const distanceM = isCurveSection(loop, next) ? rawDist * curveScale : rawDist;
    return {
      sectionIndex: i,
      fromLoopId:   loop.id,
      toLoopId:     next.id,
      fromName:     loop.name,
      toName:       next.name,
      distanceM,
    };
  });
}
